<template>
<main>
  <nav>
    <div class="avatar">
      <img @click="navigateToParam('coupons','home' )" src="@/assets/images/logo.png">
      <div style="width:1px;height:100%;background-color:#CCCCCC;display: inline-block;"/>
      <img   src="@/assets/images/logo_res.png">
    </div>
    <div class="links">
      <div
        id="campaign-menu"
        class="coupons"
        @click="showDropDown('coupons')"
      >
        <a>
          {{$t('navBar.campaigns')}}
          <i class="fas fa-caret-down"></i>
        </a>
        <div
          v-if="dropDown.coupons"
          class="subMenu sMCoupons"
        >
          <a
            v-for="subItem in campaigns"
            :key="subItem.title"
            @click="navigateToParam('coupons', subItem.name, subItem.params )"
          >
            <span v-if="subItem.access">
              <span v-if="checkPermissions(subItem.access)">{{subItem.title}}</span>
            </span>
            <span v-else>{{subItem.title}}</span>
          </a>
        </div>
      </div>
      <div
        id="settings-menu"
        v-if="menu.settings"
        class="settings"
        @click="showDropDown('settings')"
      >
        <a>
          {{$t('navBar.settings')}}
          <i class="fas fa-caret-down"></i>
        </a>
        <div
          v-if="dropDown.settings"
          class="subMenu sMSettings"
        >
          <a
            v-for="subItem in settings"
            :key="subItem.title"
            @click="navigateToParam('settings', subItem.name)"
          >
            <span v-if="subItem.access">
              <span v-if="checkPermissions(subItem.access)">{{subItem.title}}</span>
            </span>
            <span v-else>{{subItem.title}}</span>
          </a>
        </div>
      </div>
      <div id="search-menu">
        <a @click="showDropDown('search')">{{$t('navBar.search')}}</a>
      </div>
    </div>
    <div class="userNav links">
      <div
        id="language-menu"
        class="alignCenter"
        @click="showDropDown('lang')"
      >
        <div class="row alignCenter">
          <img
            v-if="$i18n.locale == 'fr'"
            src="@/assets/flags/fr.svg"
            class="flag"
            :alt="$i18n.locale"
          >
          <img
            v-if="$i18n.locale == 'en'"
            src="@/assets/flags/en.svg"
            class="flag"
            :alt="$i18n.locale"
          >
          <i class="fas fa-caret-down"></i>
        </div>
      </div>
      <div
        v-if="dropDown.lang"
        class="subMenu sMLang"
      >
        <a
          class="row alignCenter"
          @click="switchLocale('fr')"
        >
          <img
            src="@/assets/flags/fr.svg"
            class="flag"
            alt="fr"
          > Français
        </a>
        <a
          class="row alignCenter"
          @click="switchLocale('en')"
        >
          <img
            src="@/assets/flags/en.svg"
            class="flag"
            alt="en"
          > English
        </a>
      </div>
      <div
        id="user-menu"
        class="pointer"
        @click="showDropDown('user')"
      >
        {{getUserInfo()}}
        <i class="fas fa-caret-down"></i>
      </div>
      <div
        v-if="dropDown.user"
        class="subMenu sMUser"
      >
        <a @click="userLogout()">{{$t('navBar.logout')}}</a>
        <router-link :to="{name: 'updatePassword'}">{{$t('navBar.updatePassword')}}</router-link>
      </div>
    </div>
  
  </nav>
   <div :style="lineStyle"/>
</main>
</template>

<script>
import cookie from "vue-cookie";

export default {
  data() {
    return {
      process:"",
      lastClick: "",
      lineStyle:{
          backgroundColor:process.env.VUE_APP_COLOR,
          display:'block',
          "padding-top":'5px',
      },
      menu: {
        settings: true
      },
      dropDown: {
        coupons: false,
        settings: false,
        user: false,
        lang: false
      }
    };
  },
  created() {
    document.addEventListener("click", this.documentMenuClick);
  },
  destroyed() {
    document.removeEventListener("click", this.documentMenuClick);
  },
  computed: {
    campaigns() {
      return [
        {
          title: this.$t("navBar.createCampaign"),
          name: "createCampaign",
          access: ["campaign-administration"]
        },
       /* {
          title: this.$t("navBar.assignCoupon"),
          name: "assignCoupons",
          access: ["coupon-retrieval"]
        },*/
        {
          title: this.$t("navBar.activeCampaigns"),
          name: "allCampaigns",
          params: { campaignType: "active" }
        },
        {
          title: this.$t("navBar.archivedCampaigns"),
          name: "allCampaigns",
          params: { campaignType: "archived" }
        }
      ];
    },
    settings() {
      return [
        {
          title: this.$t("navBar.salesChannels"),
          name: "allSalesChannels",
          access: ["sales-channel-administration"]
        },
        {
          title: this.$t("navBar.products"),
          name: "allProducts",
          access: ["product-administration"]
        },
        {
          title: this.$t("navBar.profiles"),
          name: "allProfiles",
          access: ["user-profile-administration"]
        },
        {
          title: this.$t("navBar.users"),
          name: "allUsers",
          access: ["user-administration", "user-invitation"]
        }
      ];
    }
  },
  mounted() {
    this.initMenu();
  },
  methods: {
    documentMenuClick(evt) {
      var targetElement = evt.target;

      if (this.searchParentClickItemMenu(targetElement)) return;
      this.showDropDown("");
    },
    searchParentClickItemMenu(target) {
      do {
        var campaignMenuElement = document.getElementById("campaign-menu");
        var settingsMenuElement = document.getElementById("settings-menu");
        var searchMenuElement = document.getElementById("search-menu");
        var languageMenuElement = document.getElementById("language-menu");
        var userMenuElement = document.getElementById("user-menu");
        if (
          target == campaignMenuElement ||
          target == settingsMenuElement ||
          target == searchMenuElement ||
          target == languageMenuElement ||
          target == userMenuElement
        ) {
          return true;
        }
        // Go up the DOM
        target = target.parentNode;
      } while (target);
      return false;
    },
    navItemClick(id) {
      this.lastClick = id;
      this.showDropDown(id);
    },
    navItemAction(id) {
      if (this.dropDown[id] && this.lastClick == id) {
        return true;
      }
    },
    initMenu() {
      let profile = this.$store.getters.USERPROFILE;
      if (
        !profile["user-administration"] &&
        !profile["product-administration"] &&
        !profile["sales-channel-administration"] &&
        !profile["user-profile-administration"] && !profile["user-invitation"]
      ) {
        this.menu.settings = false;
      }
    },
    userLogout() {
      this.$store.commit("LOG_OUT");
      //delete cookie info
      cookie.delete("mgc-authToken");
      cookie.delete("mgc-u-id");
      this.$router.push({ name: "login" });
    },
    checkPermissions(permissionList) {
      for (var i = 0; i < permissionList.length; i++) {
        if (this.$store.getters.USERPROFILE[permissionList[i]]) {
          return true;
        }
      }
      return false;
    },

    showDropDown(context) {
      switch (context) {
        case "coupons":
          this.dropDown.coupons = !this.dropDown.coupons;
          this.dropDown.settings = false;
          this.dropDown.user = false;
          this.dropDown.lang = false;
          break;
        case "settings":
          this.dropDown.settings = !this.dropDown.settings;
          this.dropDown.coupons = false;
          this.dropDown.user = false;
          this.dropDown.lang = false;
          break;
        case "user":
          this.dropDown.user = !this.dropDown.user;
          this.dropDown.settings = false;
          this.dropDown.coupons = false;
          this.dropDown.lang = false;
          break;
        case "lang":
          this.dropDown.lang = !this.dropDown.lang;
          this.dropDown.user = false;
          this.dropDown.settings = false;
          this.dropDown.coupons = false;
          break;
        case "search":
          this.dropDown.lang = false;
          this.dropDown.user = false;
          this.dropDown.settings = false;
          this.dropDown.coupons = false;
          this.$router.push({ name: "search" });
          break;
        default:
          this.dropDown.lang = false;
          this.dropDown.user = false;
          this.dropDown.settings = false;
          this.dropDown.coupons = false;
          break;
      }
    },
    navigateTo(context, link) {
      this.$router.push({ path: link });
    },
    navigateToParam(context, pagename, parameters) {
      this.$router.push({ name: pagename, params: parameters });
    },
    switchLocale(lang) {
      this.$i18n.locale = lang;
      this.dropDown.lang = false;
    },
    getUserInfo() {
      return this.$store.getters.NAME;
    }
  }
};
</script>

<style scoped>
.avatar {
  width: 10%;
  padding: 5px;
}
.links {
  display: flex;
  line-height: 50px;
}
.links > div {
  margin-right: 22px;
}
.avatar > img {
    margin-left: 5px;
    text-align: center;
    padding-bottom: 5px;
    height: 30px;
    /* border-radius: 50px;*/
}
.coupons,
.settings,
.userNav {
  position: relative;
}
.subMenu {
  background-color: white;
  position: absolute;
  width: 185px;
  border: solid 1px #cccccc;
  text-align: left;
  padding-left: 15px;
  display: flex;
  flex-direction: column;
}
.sMCoupons {
  right: -22px;
}
.sMSettings {
  left: 0px;
}
.sMUser {
  top: 50px;
  right: 0px;
  width: 300px;
}
.sMLang {
  top: 50px;
  right: 180px;
  width: 125px;
}
.sMLang img {
  margin-left: 8px;
  margin-right: 8px;
}
a {
  color: #373a3c;
  font-weight: 400;
  font-size: 1.125em;
}
.subMenu > a:hover {
  color: #1da4ba;
  font-weight: 500;
}
.userNav {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 15px;
}
.userNav i {
  margin-left: 8px;
}
.flag {
  height: 25px;
}
</style>
